const Spinner = () => {
  return (
    <div className="inline-block w-[60px] h-[60px] rounded-full border-[5px] border-t-black/20 border-r-black/20 animate-spin"></div>
  );
};
export default Spinner;
